import { Examples } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  Examples,
  React
};